import axios from "axios";

const createTechItemReturn = async (body) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/techItemReturn`, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllTechItemReturn = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/techItemReturn`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechItemReturn = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/techItemReturn/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getTechItemReturnBySeq = async (params) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/techItemReturn/get-byseq${params || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};
const getSeqNoTechItemReturn = async (params) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/techItemReturn/get-seq-no${params || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editTechItemReturn = async (id, body) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/techItemReturn/${id}`, body)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteTechItemReturn = async (id) => {
  return axios
    .delete(`${process.env.REACT_APP_API_URL}/techItemReturn/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const TechItemReturnService = {
  createTechItemReturn,
  getAllTechItemReturn,
  getTechItemReturn,
  getTechItemReturnBySeq,
  getSeqNoTechItemReturn,
  editTechItemReturn,
  deleteTechItemReturn
};

export default TechItemReturnService;
